import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  imgWrapperMulti: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  deleteAttributeWrapper: {
    position: "absolute",
    bottom: "24px",
    left: "1.5rem",
    fontSize: "12px",
    fontWeight: 700,
    color: "#CC0001",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  deleteAttributeImg: {
    width: "20px",
    marginRight: "7px",
    position: "relative",
    top: "3px"
  },
  disabledDeleteBtn: {
    opacity: "30%",
    cursor: "default",
  },
  eaAlertContent: {
    color: "#CC7B00"
  },
  requiredTxt: {
    color: "#9A9AAF",
    fontSize: "18px",
    marginLeft: "5px"
  },
}));

export default useStyles;
